import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '@angular/cdk/layout';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {BarComponent} from './components/layouts/app-layout/bar/bar.component';
import {MenuComponent} from './components/layouts/app-layout/menu/menu.component';
import {LoginPageComponent} from './pages/login/login-page.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {HttpClientModule} from '@angular/common/http';
import {HomePageComponent} from './pages/home/home-page.component';
import {MeService} from './services/api/me.service';
import {TestsPageComponent} from './pages/tests/tests/tests-page.component';
import {TestQuestionsPageComponent} from './pages/tests/test-questions/test-questions-page.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TestCreateDialogComponent} from './components/dialogs/test-create-dialog/test-create-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {TestsTableComponent} from './components/tables/tests-table/tests-table.component';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {getRusPaginatorIntl} from './providers/rus-paginator-intl';
import {TextEditorComponent} from './components/editors/simple-editors/text-editor/text-editor.component';
import {registerLocaleData} from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import {QuestionCreateDialogComponent} from './components/dialogs/question-create-dialog/question-create-dialog.component';
import {MatRadioModule} from '@angular/material/radio';
import {QuestionEditFormComponent} from './components/forms/question-edit-form/question-edit-form.component';
import {AnswerTextEditFormComponent} from './components/forms/answer-text-edit-form/answer-text-edit-form.component';
import {AnswerOptionsEditorComponent} from './components/editors/answer-options-editor/answer-options-editor.component';
import {AnswerOptionCreateFormComponent} from './components/forms/answer-option-create-form/answer-option-create-form.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AnswerOptionEditFormComponent} from './components/forms/answer-option-edit-form/answer-option-edit-form.component';
import {AnswerOptionDeleteDialogComponent} from './components/dialogs/answer-option-delete-dialog/answer-option-delete-dialog.component';
import {QuestionDeleteDialogComponent} from './components/dialogs/question-delete-dialog/question-delete-dialog.component';
import {TestDeleteDialogComponent} from './components/dialogs/test-delete-dialog/test-delete-dialog.component';
import {QuestionsEditorComponent} from './components/editors/questions-editor/questions-editor.component';
import {TestPageComponent} from './pages/tests/test/test-page.component';
import {PageLayoutComponent} from './components/layouts/page-layout/page-layout/page-layout.component';
import {PageBarComponent} from './components/layouts/page-layout/page-bar/page-bar.component';
import {PageContentComponent} from './components/layouts/page-layout/page-content/page-content.component';
import {DurationEditorComponent} from './components/editors/simple-editors/duration-editor/duration-editor.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DurationPickerDialogComponent} from './components/dialogs/duration-picker-dialog/duration-picker-dialog.component';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {TestLinksTableComponent} from './components/tables/test-links-table/test-links-table.component';
import {TestLinkCreateDialogComponent} from './components/dialogs/test-link-create-dialog/test-link-create-dialog.component';
import {TestLinkEditDialogComponent} from './components/dialogs/test-link-edit-dialog/test-link-edit-dialog.component';
import {TestLinkDeleteDialogComponent} from './components/dialogs/test-link-delete-dialog/test-link-delete-dialog.component';
import {TestLinksEditorComponent} from './components/editors/test-links-editor/test-links-editor.component';
import {DateAdapter, MatNativeDateModule} from '@angular/material/core';
import {TestActivateDialogComponent} from './components/dialogs/test-activate-dialog/test-activate-dialog.component';
import {TestDeactivateDialogComponent} from './components/dialogs/test-deactivate-dialog/test-deactivate-dialog.component';
import {TestExecutionPageComponent} from './pages/test-execution/test-execution-page.component';
import {TestExecutionStartComponent} from './components/execution/test-execution-start/test-execution-start.component';
import {TestExecutionRegisterFormComponent} from './components/execution/test-execution-register-form/test-execution-register-form.component';
import {TimeComponent} from './components/time/time/time.component';
import {TestExecutionComponent} from './components/execution/test-execution/test-execution.component';
import {TestExecutionFinishComponent} from './components/execution/test-execution-finish/test-execution-finish.component';
import {LocaleDateAdapter} from './providers/locale-date-adapter.service';
import {QuestionsExecutionComponent} from './components/execution/questions-execution/questions-execution.component';
import {TimerComponent} from './components/time/timer/timer.component';
import {QuestionExecutionNumbersComponent} from './components/execution/question-execution-numbers/question-execution-numbers.component';
import {QuestionExecutionComponent} from './components/execution/question-execution/question-execution.component';
import {AnswerOptionsExecutionComponent} from './components/execution/answer-options-execution/answer-options-execution.component';
import {AnswerTextExecutionComponent} from './components/execution/answer-text-execution/answer-text-execution.component';
import {TestExecutionFinishDialogComponent} from './components/dialogs/test-execution-finish-dialog/test-execution-finish-dialog.component';
import {TestExecutionExpiredComponent} from './components/execution/test-execution-expired/test-execution-expired.component';
import {TestResultsPageComponent} from './pages/tests/test-results/test-results-page.component';
import {TestResultPageComponent} from './pages/tests/test-result/test-result-page.component';
import {TestResultsTableComponent} from './components/tables/test-results-table/test-results-table.component';
import {TestResultComponent} from './components/result/test-result/test-result.component';
import {TimeDurationComponent} from './components/time/time-duration/time-duration.component';
import {TimeEventComponent} from './components/time/time-event/time-event.component';
import {QuestionResultsComponent} from './components/result/question-results/question-results.component';
import {QuestionResultComponent} from './components/result/question-result/question-result.component';
import {AnsweredOptionsResultComponent} from './components/result/answered-options-result/answered-options-result.component';
import {AnsweredTextResultComponent} from './components/result/answered-text-result/answered-text-result.component';
import {QuestionResultCheckComponent} from './components/result/question-result-check/question-result-check.component';
import {TestResultCommitDialogComponent} from './components/dialogs/test-result-commit-dialog/test-result-commit-dialog.component';
import {TestResultCancelDialogComponent} from './components/dialogs/test-result-cancel-dialog/test-result-cancel-dialog.component';
import {TestFiltersComponent} from './components/forms/filters/test-filters/test-filters.component';
import {TestResultFiltersComponent} from './components/forms/filters/test-result-filters/test-result-filters.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {TestResultDeleteDialogComponent} from './components/dialogs/test-result-delete-dialog/test-result-delete-dialog.component';
import {UsersPageComponent} from './pages/users/users/users-page.component';
import {UsersTableComponent} from './components/tables/users-table/users-table.component';
import {UserCreateDialogComponent} from './components/dialogs/user-create-dialog/user-create-dialog.component';
import {UserFiltersComponent} from './components/forms/filters/user-filters/user-filters.component';
import {UserPageComponent} from './pages/users/user/user-page.component';
import {DialogChecksComponent} from './components/dialogs-components/dialog-checks/dialog-checks.component';
import {DialogCheckComponent} from './components/dialogs-components/dialog-check/dialog-check.component';
import {BarTitleComponent} from './components/layouts/bar-layout/bar-title/bar-title.component';
import {TestRenameDialogComponent} from './components/dialogs/test-rename-dialog/test-rename-dialog.component';
import {BarBackButtonComponent} from './components/layouts/bar-layout/bar-back-button/bar-back-button.component';
import {BarMoreButtonComponent} from './components/layouts/bar-layout/bar-more-button/bar-more-button.component';
import {UserBlockDialogComponent} from './components/dialogs/user-block-dialog/user-block-dialog.component';
import {UserUnblockDialogComponent} from './components/dialogs/user-unblock-dialog/user-unblock-dialog.component';
import {UserDeleteDialogComponent} from './components/dialogs/user-delete-dialog/user-delete-dialog.component';
import {UserEditDialogComponent} from './components/dialogs/user-edit-dialog/user-edit-dialog.component';
import {UserResetPasswordDialogComponent} from './components/dialogs/user-reset-password-dialog/user-reset-password-dialog.component';
import {MePageComponent} from './pages/me/me-page.component';
import {MeChangePasswordDialogComponent} from './components/dialogs/me-change-password-dialog/me-change-password-dialog.component';
import {PositionPickerDialogComponent} from './components/dialogs/position-picker-dialog/position-picker-dialog.component';
import {TestResultsExportDialogComponent} from './components/dialogs/test-results-export-dialog/test-results-export-dialog.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';

registerLocaleData(localeRu, 'ru');

const initializeApp = (meService: MeService) => {
  return (): Promise<any> => {
    return meService.fetchAll();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    BarComponent,
    MenuComponent,
    LoginPageComponent,
    HomePageComponent,
    TestsPageComponent,
    TestQuestionsPageComponent,
    TestCreateDialogComponent,
    TestsTableComponent,
    TextEditorComponent,
    QuestionCreateDialogComponent,
    QuestionEditFormComponent,
    AnswerTextEditFormComponent,
    AnswerOptionsEditorComponent,
    AnswerOptionCreateFormComponent,
    AnswerOptionEditFormComponent,
    AnswerOptionDeleteDialogComponent,
    QuestionDeleteDialogComponent,
    TestDeleteDialogComponent,
    QuestionsEditorComponent,
    TestPageComponent,
    PageLayoutComponent,
    PageBarComponent,
    PageContentComponent,
    DurationEditorComponent,
    DurationPickerDialogComponent,
    TestLinksTableComponent,
    TestLinkCreateDialogComponent,
    TestLinkEditDialogComponent,
    TestLinkDeleteDialogComponent,
    TestLinksEditorComponent,
    TestActivateDialogComponent,
    TestDeactivateDialogComponent,
    TestExecutionPageComponent,
    TestExecutionStartComponent,
    TestExecutionRegisterFormComponent,
    TimeComponent,
    TestExecutionComponent,
    TestExecutionFinishComponent,
    QuestionsExecutionComponent,
    TimerComponent,
    QuestionExecutionNumbersComponent,
    QuestionExecutionComponent,
    AnswerOptionsExecutionComponent,
    AnswerTextExecutionComponent,
    TestExecutionFinishDialogComponent,
    TestExecutionExpiredComponent,
    TestResultsPageComponent,
    TestResultPageComponent,
    TestResultsTableComponent,
    TestResultComponent,
    TimeDurationComponent,
    TimeEventComponent,
    QuestionResultsComponent,
    QuestionResultComponent,
    AnsweredOptionsResultComponent,
    AnsweredTextResultComponent,
    QuestionResultCheckComponent,
    TestResultCommitDialogComponent,
    TestResultCancelDialogComponent,
    TestFiltersComponent,
    TestResultFiltersComponent,
    TestResultDeleteDialogComponent,
    UsersPageComponent,
    UsersTableComponent,
    UserCreateDialogComponent,
    UserFiltersComponent,
    UserPageComponent,
    DialogChecksComponent,
    DialogCheckComponent,
    BarTitleComponent,
    TestRenameDialogComponent,
    BarBackButtonComponent,
    BarMoreButtonComponent,
    UserBlockDialogComponent,
    UserUnblockDialogComponent,
    UserDeleteDialogComponent,
    UserEditDialogComponent,
    UserResetPasswordDialogComponent,
    MePageComponent,
    MeChangePasswordDialogComponent,
    PositionPickerDialogComponent,
    TestResultsExportDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatCardModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatMenuModule,
    MatSnackBarModule,
    DragDropModule,
  ],
  providers: [
    {provide: APP_INITIALIZER, useFactory: initializeApp, deps: [MeService], multi: true},
    {provide: MatPaginatorIntl, useValue: getRusPaginatorIntl()},
    {provide: LOCALE_ID, useValue: 'ru'},
    {provide: DateAdapter, useClass: LocaleDateAdapter},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
